import Ajv from 'ajv';
import omitBy from 'lodash/omitBy';
import get from 'lodash/get';

import { formats } from '../../../../spec/schemas/formats/formats';

export function hasErrors(validationResult) {
  return validationResult.length > 0;
}

export function humanizeErrors(validationResult, schema) {
  return validationResult.map((error) => {
    const property = get(error.schemaPath.split('/'), 2, error.dataPath.replace('.', ''));

    const { keyword } = error;
    const schemaProperty = schema.properties[property];
    const schemaMessage =
      schemaProperty && schemaProperty.messages && schemaProperty.messages[keyword];
    return {
      error,
      property,
      message: schemaMessage || error.message,
    };
  });
}

const ignoredValues = ['', null, undefined, NaN];
const makeOmitPredicate = (ignored) => (value) =>
  ignoredValues.concat(ignored).indexOf(value) !== -1;

export function omitEmpty(form, ignored) {
  const result = omitBy(form, makeOmitPredicate(ignored));
  return result;
}

// TODO: Deprecate this
function rawValidate(data, schema, options) {
  const defaultOptions = {
    v5: true,
    allErrors: true,
    errorDataPath: 'property',
    format: 'full',
    useDefaults: true,
  };
  const ajv = Ajv({ ...defaultOptions, ...options });
  const validate = ajv.compile(schema);
  const valid = validate(omitEmpty(data));
  return valid ? [] : validate.errors;
}

const filterNonInputErrors = (errors, inputName) =>
  errors.filter((error) => error.property !== inputName);

const filterInputErrors = (errors, inputName) =>
  errors.filter((error) => error.property === inputName);

export const mergeErrors = (oldErrors, nextErrors, inputName) => [
  ...filterNonInputErrors(oldErrors, inputName),
  ...filterInputErrors(nextErrors, inputName),
];

export const makeFormValidator = (schema, options) => (form, inputName, prevErrors) => {
  const defaultOptions = {
    allErrors: true,
    $data: true,
    errorDataPath: 'property',
    format: 'full',
    formats,
    useDefaults: true,
    v5: true,
  };
  const ajv = Ajv({ ...defaultOptions, ...options });
  const schemaAsObject =
    typeof schema === 'function' ? schema(form, inputName, prevErrors) : schema;

  const validate = ajv.compile(schemaAsObject);
  const nextData = omitEmpty(form);
  const valid = validate(nextData);

  if (valid) return Promise.resolve(nextData);

  const currentErrors = humanizeErrors(validate.errors, schemaAsObject);
  const finalErrors = inputName ? mergeErrors(prevErrors, currentErrors, inputName) : currentErrors;

  return finalErrors.length > 0 ? Promise.reject(finalErrors) : Promise.resolve(nextData);
};

export default rawValidate;
